import React from 'react';
import { ClassHelper } from 'components/lib';
import Style from './label.tailwind.js';

export function Label(props) {
  const labelStyle = ClassHelper(Style, props);

  return (
    <label className={labelStyle} htmlFor={props.for} style={{ fontSize: 16, fontWeight: 500, ...props.style }}>
      {props.text}
    </label>
  );
}
